import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

function LabeledInput({ label, testId, ...props }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-widest text-igc-muted mb-1.5 block">{label}</label>
      <Input data-testid={testId} className="bg-igc-surfaceLight border-igc-gold/20" {...props} />
    </div>
  );
}

export function ClientProfileFields({ form, setForm, isAffiliate, sensitiveRequired = true }) {
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <div className="space-y-6">
      <div>
        <p className="text-igc-goldText text-xs uppercase tracking-widest mb-3">Personal Information</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <LabeledInput label="Legal First Name" testId="profile-first-name-input" required title="Your legal first name, exactly as it appears on your ID." value={form.first_name} onChange={set("first_name")} />
          <LabeledInput label="Legal Last Name" testId="profile-last-name-input" required title="Your legal last name, exactly as it appears on your ID." value={form.last_name} onChange={set("last_name")} />
          <LabeledInput label="Email Address" testId="profile-email-input" type="email" required title="The email address IGC will use to contact you and send account notifications." value={form.email} onChange={set("email")} />
          <LabeledInput label="Phone Number" testId="profile-phone-input" required title="A phone number IGC can use to reach you." value={form.phone} onChange={set("phone")} />
        </div>
        <div className="mt-3">
          <LabeledInput label="Personal Address" testId="profile-mailing-address-input" required title="Your home mailing address." value={form.mailing_address} onChange={set("mailing_address")} />
        </div>
      </div>

      <div>
        <p className="text-igc-goldText text-xs uppercase tracking-widest mb-3">Business Information</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <LabeledInput label="Business Name" testId="profile-business-name-input" title="The legal name of your business." value={form.business_name} onChange={set("business_name")} />
          <LabeledInput label="Business Address" testId="profile-business-address-input" title="Your business's physical or mailing address." value={form.business_address} onChange={set("business_address")} />
        </div>
      </div>

      <div>
        <p className="text-igc-goldText text-xs uppercase tracking-widest mb-3">Payment Information (ACH Banking)</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <LabeledInput label="Bank Name" testId="profile-bank-name-input" required={sensitiveRequired} title="The name of the bank where your ACH payments will be deposited." value={form.payment_bank_name} onChange={set("payment_bank_name")} />
          <LabeledInput label="Account Holder Name" testId="profile-account-holder-input" required={sensitiveRequired} title="The name on the bank account receiving payments." value={form.payment_account_holder_name} onChange={set("payment_account_holder_name")} />
          <LabeledInput label="Account Number" testId="profile-account-number-input" required={sensitiveRequired} title="Your bank account number — kept secure and used only to process your payouts." value={form.payment_account_number} onChange={set("payment_account_number")} />
          <LabeledInput label="Routing Number" testId="profile-routing-number-input" required={sensitiveRequired} title="Your bank's routing number." value={form.payment_routing_number} onChange={set("payment_routing_number")} />
          <div>
            <label className="text-[11px] uppercase tracking-widest text-igc-muted mb-1.5 block">Account Type</label>
            <Select value={form.account_type || ""} onValueChange={(v) => setForm({ ...form, account_type: v })}>
              <SelectTrigger data-testid="profile-account-type-select" title="Whether the account above is a Checking or Savings account." className="bg-igc-surfaceLight border-igc-gold/20"><SelectValue placeholder="Checking or Savings" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Checking">Checking</SelectItem>
                <SelectItem value="Savings">Savings</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <p className="text-igc-muted text-[11px] mt-3" data-testid="payment-schedule-note">
          Payment Schedule: Referral and commission payments are processed twice monthly, on the 1st and 15th, directly to your account on file.
        </p>
      </div>

      {isAffiliate && (
        <div>
          <p className="text-igc-goldText text-xs uppercase tracking-widest mb-3">1099 Information (Affiliates)</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <LabeledInput label="Legal Name" testId="profile-legal-name-input" required={sensitiveRequired} title="Your full legal name as it appears on your tax filings." value={form.legal_name} onChange={set("legal_name")} />
            <div>
              <label className="text-[11px] uppercase tracking-widest text-igc-muted mb-1.5 block">Tax ID Type</label>
              <Select value={form.tax_id_type} onValueChange={(v) => setForm({ ...form, tax_id_type: v })}>
                <SelectTrigger data-testid="profile-tax-id-type-select" className="bg-igc-surfaceLight border-igc-gold/20"><SelectValue placeholder="SSN or EIN" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="SSN">SSN</SelectItem>
                  <SelectItem value="EIN">EIN</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <LabeledInput label="SSN or EIN Number" testId="profile-tax-id-input" required={sensitiveRequired} title="Your Social Security Number or Employer Identification Number, used only for tax reporting on your payouts." value={form.tax_id} onChange={set("tax_id")} />
            <LabeledInput label="Tax Mailing Address" testId="profile-tax-mailing-address-input" required={sensitiveRequired} title="The mailing address the IRS has on file for you or your business." value={form.tax_mailing_address} onChange={set("tax_mailing_address")} />
          </div>
        </div>
      )}
    </div>
  );
}
